// apps/web/src/components/landing-v2/proofs/JournalProof.tsx
/** Theme 03 / Soul journal — Cosmic-only. Three dated journal rows.
 *  Reference: handoff .mm with .mm-journal entries. */

const ENTRIES = [
  {
    month: 'Nov',
    day: '14',
    q: 'What should I trust right now?',
    c: 'The Star · upright',
    img: '/cards/the-star.webp',
  },
  {
    month: 'Nov',
    day: '11',
    q: 'Where is the doubt coming from?',
    c: 'The Moon · reversed',
    img: '/cards/the-moon.webp',
  },
  {
    month: 'Nov',
    day: '07',
    q: "What's quietly going right?",
    c: 'The Sun · upright',
    img: '/cards/the-sun.webp',
  },
]

export function JournalProof() {
  return (
    <div className="absolute inset-0 flex flex-col p-[18px]">
      <div className="flex items-baseline justify-between">
        <span className="inline-flex items-center rounded-pill border border-gold-light-legacy/30 bg-gold-light-legacy/[0.14] px-2.5 py-1 text-[10px] font-medium uppercase tracking-[0.14em] text-gold-light-legacy">
          Soul journal
        </span>
      </div>
      <div className="mt-2.5 flex flex-col">
        {ENTRIES.map((e, i) => (
          <div
            key={e.day}
            className="grid items-center gap-2.5 py-2"
            style={{
              gridTemplateColumns: '38px 1fr auto',
              borderBottom: i === ENTRIES.length - 1 ? 'none' : '1px dashed var(--hairline)',
            }}
          >
            <div className="text-center font-display text-[11px] leading-tight text-text-muted">
              {e.month}
              <strong className="block text-[16px] font-normal text-text-primary">{e.day}</strong>
            </div>
            <div>
              <div className="font-display italic text-text-primary" style={{ fontSize: '0.78rem', lineHeight: 1.3 }}>
                &ldquo;{e.q}&rdquo;
              </div>
              <span className="mt-0.5 block text-[9px] uppercase tracking-[0.16em] text-text-muted">
                {e.c}
              </span>
            </div>
            <div
              className="aspect-[5/7] w-[22px] overflow-hidden rounded border border-hairline"
              style={{ background: 'var(--color-deep-purple)' }}
            >
              <img
                src={e.img}
                alt=""
                loading="lazy"
                className="h-full w-full object-cover"
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
